/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query RoutePlanReadQuery($routeId: ID!, $mccNameToSearch: String, $mncNameToSearch: String, $operatorNameToSearch: String, $countryNameToSearch: String, $take: PositiveInt, $skip: Int, $filter: JSONObject) {
    RoutePlanRead(routeId: $routeId, mccNameToSearch: $mccNameToSearch, mncNameToSearch: $mncNameToSearch, operatorNameToSearch: $operatorNameToSearch, countryNameToSearch: $countryNameToSearch, filter: $filter, take: $take, skip: $skip) {
      id
      createdAt
      updatedAt
      priority,
      isPaused,
      isDestroyed,
      message
      status,
      _totalCount,
      Account {
        displayName
      }
      VendorAccount {
        id,
        displayName
      },
      Mcc {
        createdAt,
        updatedAt,
        mcc,
        countryName,
        dialingCode
      },
      Mnc {
        createdAt,
        updatedAt,
        mnc,
        network
      }
      Route {
        id
        displayName
      }
    }
  }
`
